import getChildrenExtraCharge from './getChildrenExtraCharge'
import getExcludedServicesTotal from './getExcludedServicesTotal'
import getExtraPersonCharge from './getExtraPersonCharge'
import getTotalOBPRate from './getTotalOBPRate'
import getTotalPPPDRate from './getTotalPPPDRate'
import { PROMO_CODE_DISCOUNT_TYPE_ENUM } from 'Rentlio/utils/promoCodeDiscountTypeEnum'

// we are calculating total rate before discount if promo code is applied
const getTotalRateBeforeDiscount = (unitTypeOccupancy, rate, adults, childrenAges) => {
  if (!rate) {
    return 0
  }
  // we are setting totalRate as totalRateBeforeDiscount so we can reuse existing funcations to calculate total rate before discount
  let ratePlan = { ...rate, totalRate: rate.totalRateBeforeDiscount }
  if (ratePlan.isPaxRate) {
    ratePlan = {
      ...ratePlan,
      paxValues: ratePlan.paxValues?.length
        ? ratePlan.paxValues.map(paxValue => ({ ...paxValue, totalRate: paxValue.totalRateBeforeDiscount }))
        : []
    }
  }

  let excludedServicesTotal = getExcludedServicesTotal(ratePlan, adults, childrenAges)
  if (ratePlan.activePromoCode && ratePlan.activePromoCode.discountType === PROMO_CODE_DISCOUNT_TYPE_ENUM.PERCENTAGE) {
    // we are getting services price already discounted from api response so we need to add discounted amount to price to get price before discount
    // Except when discountAmount is 100% then we can't get original price (in that rare case set it to 0 as default)
    excludedServicesTotal = excludedServicesTotal / (1 - Number(ratePlan.activePromoCode.discountAmount) / 100) || 0
  }

  ratePlan.activePromoCode = null

  if (ratePlan.isPaxRate) {
    return getTotalOBPRate(ratePlan, adults, childrenAges, unitTypeOccupancy) + excludedServicesTotal
  }

  if (ratePlan.isPPPDRate) {
    return getTotalPPPDRate(ratePlan, adults, childrenAges) + excludedServicesTotal
  }

  return (
    ratePlan.totalRate +
    excludedServicesTotal +
    getExtraPersonCharge(unitTypeOccupancy, ratePlan, adults) +
    getChildrenExtraCharge(unitTypeOccupancy, ratePlan, childrenAges)
  )
}

export default getTotalRateBeforeDiscount
